export const SET_FILTER = 'SET_FILTER';
export const FETCH_LIST = 'FETCH_LIST';
export const SET_LIST = 'SET_LIST';
export const SET_PAGE_NUM = 'SET_PAGE_NUM';
export const SET_PAGE_COUNT = 'SET_PAGE_COUNT';
export const SET_COMPONENT = 'SET_COMPONENT';
export const SET_LIVE_ROOM = 'SET_LIVE_ROOM';
